module.exports = "<p>\n  finance works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/finance/finance.component.html
// module id = ./src/app/web/game/management/business-units/finance/finance.component.html
// module chunks = main